import {
  IDatabaseInstanceDocument,
  IPracticeMigration,
  PracticeMigrationStatus,
} from '@principle-theorem/practice-migrations/interfaces';
import {
  IBrand,
  IOrganisation,
  IPractice,
} from '@principle-theorem/principle-core/interfaces';
import {
  BaseFirestoreMock,
  Properties,
  Timezone,
} from '@principle-theorem/shared';
import { MockDocRef, MockNamedDocument } from '@principle-theorem/testing';

export class PracticeMigrationMock
  extends BaseFirestoreMock<Properties<IPracticeMigration>>
  implements Properties<IPracticeMigration>
{
  metadata = {
    name: 'test',
    version: '1',
    supportsMultiplePractices: false,
  };
  source = {
    metadata: {
      name: 'test',
      version: '1',
    },
    configuration: [],
  };
  destination = {
    metadata: {
      name: 'test',
      description: 'test',
    },
    configuration: [],
  };
  mappings = {
    metadata: {
      label: 'test',
      description: 'test',
    },
  };
  status = PracticeMigrationStatus.Pending;
  instanceRef = MockDocRef<IDatabaseInstanceDocument>();
  translationMaps = [];
  manualTranslationMap = [];
  configuration = {
    organisation: MockNamedDocument<IOrganisation>('organisation'),
    brand: MockNamedDocument<IBrand>('brand'),
    practices: [MockNamedDocument<IPractice>('practice')],
    projectId: '1',
    destinationBucket: 'test',
    timezone: Timezone.AustraliaSydney,
    backupDate: 'test',
  };
}
